import type * as SpawnBrowser from './spawn-browser';
import { refuseUnported } from '../janus-engine/unported';

type SpawnApi = Pick<typeof SpawnBrowser, 'previewSpawnDraft' | 'previewInventory' | 'commitEncounterInventorySpawn' | 'commitCreatureSpawn' | 'loadSpawnEncounter' | 'preflightCreatureSpawn' | 'syncSpawnLairs' | 'planInventoryBirths' | 'loadSpawnSources' | 'creatureDefinitionMaximum'>;
declare global { interface Window { ftSpawnBrowser?: SpawnApi } }

/** Early cards can request a preview before the pre-template engine has loaded. */
function ready(): Promise<SpawnApi> {
    if (window.ftSpawnBrowser) return Promise.resolve(window.ftSpawnBrowser);
    return new Promise(resolve => window.addEventListener('ft:spawn-browser-ready', () => resolve(window.ftSpawnBrowser!), { once: true }));
}
export async function previewSpawnDraft(...args: Parameters<SpawnApi['previewSpawnDraft']>): ReturnType<SpawnApi['previewSpawnDraft']> {
    return (await ready()).previewSpawnDraft(...args);
}
export async function commitCreatureSpawn(...args: Parameters<SpawnApi['commitCreatureSpawn']>): ReturnType<SpawnApi['commitCreatureSpawn']> {
    return (await ready()).commitCreatureSpawn(...args);
}
export async function loadSpawnEncounter(...args: Parameters<SpawnApi['loadSpawnEncounter']>): ReturnType<SpawnApi['loadSpawnEncounter']> {
    return (await ready()).loadSpawnEncounter(...args);
}
export async function preflightCreatureSpawn(...args: Parameters<SpawnApi['preflightCreatureSpawn']>): ReturnType<SpawnApi['preflightCreatureSpawn']> {
    return (await ready()).preflightCreatureSpawn(...args);
}
export async function syncSpawnLairs(...args: Parameters<SpawnApi['syncSpawnLairs']>): ReturnType<SpawnApi['syncSpawnLairs']> {
    return (await ready()).syncSpawnLairs(...args);
}
export function spawnFailure(error: unknown): void {
    refuseUnported(error instanceof Error ? error.message : 'spawn:planning-failed');
}
export async function previewInventory(...args: Parameters<SpawnApi['previewInventory']>): ReturnType<SpawnApi['previewInventory']> {
    return (await ready()).previewInventory(...args);
}
export async function commitEncounterInventorySpawn(...args: Parameters<SpawnApi['commitEncounterInventorySpawn']>): ReturnType<SpawnApi['commitEncounterInventorySpawn']> {
    return (await ready()).commitEncounterInventorySpawn(...args);
}
export async function planInventoryBirths(...args: Parameters<SpawnApi['planInventoryBirths']>): ReturnType<SpawnApi['planInventoryBirths']> {
    const api = window.ftSpawnBrowser ?? window.parent.ftSpawnBrowser;
    if (!api?.planInventoryBirths) throw new Error('unported:inventory-birth-planner-unavailable');
    return api.planInventoryBirths(...args);
}

/** Read-only source hydration through the pre-template spawn owner. */
export async function loadSpawnSources(...args: Parameters<SpawnApi['loadSpawnSources']>): ReturnType<SpawnApi['loadSpawnSources']> {
    const api = window.ftSpawnBrowser ?? window.parent?.ftSpawnBrowser;
    if (!api?.loadSpawnSources) throw new Error('spawn:source-reader-unavailable');
    return api.loadSpawnSources(...args);
}
export async function creatureDefinitionMaximum(...args: Parameters<SpawnApi['creatureDefinitionMaximum']>): ReturnType<SpawnApi['creatureDefinitionMaximum']> {
    const api = window.ftSpawnBrowser ?? window.parent?.ftSpawnBrowser;
    if (!api?.creatureDefinitionMaximum) throw new Error('modify-template:source-reader-unavailable');
    return api.creatureDefinitionMaximum(...args);
}
